module.exports = __webpack_public_path__ + "static/media/ex-copy-trading-icon1.2c76fece.svg";